import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import type { CloneAction } from '@api/api';
import { endpoints } from '../../api/endpoints';
import { useNotify } from '../../components/Notify';
import { jobLabel } from '../../components/JobView';

/** Runs a clone action and jumps to the job it started. */
export function useCloneAction(cloneId: number) {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const notify = useNotify();
  return useMutation({
    mutationFn: ({ action, body }: { action: CloneAction; body?: Record<string, unknown> }) => endpoints.action(cloneId, action, body),
    onSuccess: (job) => {
      notify.ok(`${jobLabel(job.type)} started (job #${job.id})`);
      void qc.invalidateQueries({ queryKey: ['clone', cloneId] });
      void qc.invalidateQueries({ queryKey: ['clones'] });
      void qc.invalidateQueries({ queryKey: ['overview'] });
      navigate(`/clones/${cloneId}/jobs?job=${job.id}`);
    },
    onError: (e) => notify.error(e),
  });
}
